import React from "react";

import { useContentContext } from "../../context/content-context";

const BasicHero = () => {
  const { pageTitle } = useContentContext();

  if (pageTitle) {
    return (
      <section className="basic-hero patient section-outer">
        <div className="section-inner">
          <h1 className="white">{pageTitle}</h1>
        </div>
      </section>
    );
  }

  return null;
};

export default BasicHero;
